module.exports = __webpack_public_path__ + "supplier/img/new_table_empty2x.9969fef1.png";